import { useApolloClient } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from 'graphql/secure/fragments/document.fragments';
import { useParams } from 'react-router-dom';
import { IBaseDocument } from 'FeatureModules/Document/types/document.types';

interface IReturnProps {
  document: IBaseDocument | null;
}

/**
 * Getting the document that is currently active from the cache
 * Used currently to get the document title for the sidebar menu
 */

const useActiveDocument = (): IReturnProps => {
  const client = useApolloClient();
  const { cache } = client;
  const { documentId } = useParams<{ documentId: string }>();
  const cacheKey = cache.identify({
    __typename: 'Document',
    id: documentId,
  });
  const documentInCache = client.readFragment<IBaseDocument>({
    fragment: DOCUMENT_FRAGMENT,
    fragmentName: 'documentValues',
    id: cacheKey,
  });

  // Getting only the cache version cause right now it will already be fetched on a different location
  return { document: documentInCache };
};

export default useActiveDocument;
